import React, { Fragment } from "react";
import { BeatLoader } from "react-spinners";
import { Button } from "./Button";
import { GreyColor } from "../configs/globals";

export const ButtonLoader = ({
  type = "button",
  variant = "primary",
  disabled = false,
  text = "",
  executingText = "",
  isExecuting = false,
  color = GreyColor,
  tooltip = "",
  ...props
}) => (
  <span title={tooltip}>
    <Button type={type} variant={variant} disabled={disabled} {...props}>
      {isExecuting && (
        <div className="container loader loader--center" title="TEST">
          <span className="text" style={{ color: `${color}` }}>
            {executingText}&nbsp;
          </span>
          <BeatLoader
            color={color}
            loading={isExecuting}
            size={6}
            sizeUnit={"px"}
          />
        </div>
      )}
      {!isExecuting && <Fragment>{text}</Fragment>}
    </Button>
  </span>
);
